import { useTranslation } from 'react-i18next';

const HotelDescription = ({ propiedad, ruta, lang }) => {

    const { t } = useTranslation();
    const heroImages = propiedad.fotos_web;

    return (
        <div className="mb-6 row" id="hotel">
            <div className="col-md-6">
                <figure className="o-cont-fullw o-cont-md-fullw__left not-xl-fullw__left">

                    <img className="image" src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + heroImages[0].nombre} alt="" />
                    <figcaption className="fcover">{propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ? propiedad.nombre_traducido[lang] : propiedad.nombre}</figcaption>

                </figure>
            </div>
            <div className="col-md-6 d-flex flex-column justify-content-center align-items-start">
                <h2 className="h1 h1-md-vw">{propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ? propiedad.nombre_traducido[lang] : propiedad.nombre}</h2>
                <div className="col-md-auto offset-lg-1 offset-xl-2">
                    <app-read-more >
                        <div className="js-txtoverflow" dangerouslySetInnerHTML={{ __html: propiedad.ladesc }}>
                        </div>
                        <button type="button" className="btn btn-link btn-txtoverflow" style={{ display: "none" }}> {t("Leer más")}</button>
                    </app-read-more>
                </div>
            </div>
        </div>
    );
};

export default HotelDescription;
